import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-email-template',
    templateUrl: './email-template.component.html',
    styleUrls: ['./email-template.component.scss']
})
export class EmailTemplateComponent implements OnInit {
    public project_id;
    public influencer_type_id;

    constructor(private route: ActivatedRoute) {
    }

    ngOnInit() {
        this.route.params.subscribe(
            (params) => {
                this.route.queryParams.subscribe((queryParams) => {
                    this.project_id = params['project_id'];
                    this.influencer_type_id = params['influencer_type_id'];
                });
            }
        );
    }
}
